// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fancy-scroll--view::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n", ""]);
// Exports
module.exports = exports;
